module.exports = __webpack_public_path__ + "img/sfmd5.0c0aae60.jpg";